let shop_name = Shopify.shop;
let appProxyURL = '/apps/performance-audio-customer-log/app/js/app';
let customer_login = '', customer_email_id = '', customer_password_id = '';

var initializationBtn = function initializationBtn() {
    var form_elem = document.getElementsByTagName("form");
    if (form_elem.length > 0) {
        for (var fe_i = 0; fe_i < form_elem.length; fe_i++) {
            if (form_elem[fe_i].hasAttribute("action") && form_elem[fe_i].getAttribute("action") == "/account/login") {
                let input_elem = form_elem[fe_i].getElementsByTagName("input");
                let btn_elem = form_elem[fe_i].getElementsByTagName("button");

                if (input_elem.length > 0) {
                    for (var ie_i = 0; ie_i < input_elem.length; ie_i++) {
                        if (input_elem[ie_i].hasAttribute("type") && input_elem[ie_i].getAttribute("type") == "submit") {
                            input_elem[ie_i].setAttribute("type", 'button');
                            input_elem[ie_i].setAttribute("id", 'btn_login');
                        } else if (input_elem[ie_i].hasAttribute("name") && input_elem[ie_i].getAttribute("name") == "customer[email]") {
                            customer_email_id = input_elem[ie_i].getAttribute("id");
                        } else if (input_elem[ie_i].hasAttribute("name") && input_elem[ie_i].getAttribute("name") == "customer[password]") {
                            customer_password_id = input_elem[ie_i].getAttribute("id");
                        }
                    }
                }

                if (btn_elem.length > 0) {
                    for (var be_i = 0; be_i < btn_elem.length; be_i++) {
                        if (btn_elem[be_i].hasAttribute("type") && btn_elem[be_i].getAttribute("type") == "submit") {
                            btn_elem[be_i].setAttribute("type", 'button');
                            btn_elem[be_i].classList.add('btn_login');
                        }
                    }
                }

                if (form_elem[fe_i].hasAttribute("id")) {
                    customer_login = form_elem[fe_i].getAttribute("id");
                }
            }
        }
    }
};

Element.prototype.remove = function() {
    this.parentElement.removeChild(this);
};

NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
    for (var i = this.length - 1; i >= 0; i--) {
        if (this[i] && this[i].parentElement) {
            this[i].parentElement.removeChild(this[i]);
        }
    }
};

document.addEventListener('DOMContentLoaded', function (event) {
    initializationBtn();
    if (document.getElementsByClassName('btn_login')?.length > 0) {
        let btnLogin = document.getElementsByClassName('btn_login');
        btnLogin = Array.prototype.slice.call(btnLogin);
        for (let i = 0; i < btnLogin?.length; i++) {
          btnLogin[i].addEventListener('click', function() {
              let customerEmail = this.parentNode.querySelector('[name="customer[email]"]');
              let customerPassword = this.parentNode.querySelector('[name="customer[password]"]');
              if (customerEmail?.value?.length > 0 && customerPassword?.value?.length > 0) {
                  var formData = new FormData();
                  formData.append('action', 'check_login');
                  formData.append('email', customerEmail.value);
                  formData.append('shop', shop_name);
  
                  if (document.getElementsByClassName("input--error")) {
                      var elementClassErr = document.getElementsByClassName("input--error");
                      if (elementClassErr.length > 0) {
                          for (var i = 0; i < elementClassErr.length; i++) {
                              elementClassErr[i].classList.remove("input--error");
                          }
                      }
                  }
  
                  if (document.getElementsByClassName("form-message--error")[0]) {
                      document.getElementsByClassName("form-message--error")[0].remove();
                  }
  
                  btnLogin.value = 'Please wait...';
                  btnLogin.disabled = true;
                  fetch(appProxyURL, {
                          method: "POST",
                          body: formData
                      })
                      .then(function(response) {
                          return response.json();
                      })
                      .then(function(data) {
                          if (data.SUCCESS == 'TRUE') {
                              swal(data.MESSAGE);
                              /*if (document.querySelector('#recover+div')) {
                                  var element = document.querySelector('#recover+div');
                                  element.innerText = data.MESSAGE;
                                  element.style.color = 'green';
                                  element.style.display = 'block';
                                  // element.className = element.className.replace(/\bhide\b/g, '');
  
                                  window.scrollTo({top: 0, behavior: 'smooth'});
                              }*/
  
                              btnLogin.value = customerLoginSignInText;
                              btnLogin.disabled = false;
                          } else {
                             document.getElementById(customer_login).submit();
                          }
                      });
              } else {
                  document.getElementById(customer_login).submit();
              }
          }, false);
        }
    }
});